import { render, staticRenderFns } from "./ViewPanel.vue?vue&type=template&id=24707dcd&"
import script from "./ViewPanel.vue?vue&type=script&lang=js&"
export * from "./ViewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports